import { useCallback } from 'react'
import { useLocale } from './LocaleProvider'
import { text, type Text } from './text'

/**
 * Resolve editorial copy in the reader's language.
 *
 * The companion to `useT`, and the split between them is the split in ground rule 8:
 * `useT` looks a **label** up in a catalogue by key; this reads a **paragraph** that was
 * written in both languages where it lives. See `text.ts` for why editorial copy is not
 * keyed.
 *
 * ```tsx
 * const s = useText()
 * <h2>{s(section.title)}</h2>
 * ```
 *
 * Separate from `LocaleProvider` rather than another field on its context value so the
 * pure helper stays importable by React Native and by the build, neither of which has this
 * hook's `useCallback`.
 */
export function useText(): (value: Text | string) => string {
  const { locale } = useLocale()
  // Stable per locale, so a data module mapped through it does not rebuild every render.
  return useCallback((value: Text | string) => text(value, locale), [locale])
}
